import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  rounds: [],
  storeRound: {},
  roundsList: [],
};

const roundSlice = createSlice({
  name: "rounds",
  initialState,
  reducers: {
    loadRoundsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadRoundsSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.rounds = action.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadRoundsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadRoundsListRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadRoundsListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.roundsList = action.payload?.result;
    },
    loadRoundsListFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeRoundRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeRoundSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeRound = action.payload;
    },
    storeRoundFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateRoundRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateRoundSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateRound = action.payload;
    },
    updateRoundFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    archiveRoundRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    archiveRoundSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.archivePaper = action.payload;
    },
    archiveRoundFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadAssignRoundRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadAssignRoundSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.rounds = action?.payload?.results;
    },
    loadAssignRoundFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadRoundsRequested,
  loadRoundsSuccess,
  loadRoundsFail,
  loadRoundsListRequested,
  loadRoundsListSuccess,
  loadRoundsListFail,
  loadAssignRoundRequested,
  loadAssignRoundSuccess,
  loadAssignRoundFail,
  storeRoundRequested,
  storeRoundSuccess,
  storeRoundFail,
  updateRoundRequested,
  updateRoundSuccess,
  updateRoundFail,
  archiveRoundRequested,
  archiveRoundSuccess,
  archiveRoundFail,
} = roundSlice.actions;

export default roundSlice.reducer;
